(function () {
  function initMarquee(root) {
    var track = root.querySelector('[data-rc2-track]');
    if (!track) return;

    function pause() {
      track.classList.add('is-paused');
    }
    function resume() {
      track.classList.remove('is-paused');
    }

    // Desktop: se detiene al pasar el mouse por encima
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);

    // Mobile/touch: se detiene mientras el dedo esté sobre la foto
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('touchend', resume, { passive: true });
    root.addEventListener('touchcancel', resume, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-rc2-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var marquees = e.target.querySelectorAll('[data-rc2-marquee]');
    marquees.forEach(initMarquee);
  });
})();